import palette from './palette';

export default {
  h1: {
    color: palette.text.primary,
    fontWeight: '300',
    fontSize: '96px',
    letterSpacing: '-1.5px',
    lineHeight: '112px',
  },
  h2: {
    color: palette.text.primary,
    fontWeight: '300',
    fontSize: '60px',
    letterSpacing: '-0.5px',
    lineHeight: '72px',
  },
  h3: {
    color: palette.text.primary,
    fontSize: '48px',
    lineHeight: '56px',
  },
  h4: {
    color: palette.text.primary,
    fontSize: '34px',
    lineHeight: '36px',
  },
  h5: {
    color: palette.text.primary,
    fontSize: '24px',
    letterSpacing: '0.18px',
    lineHeight: '24px',
  },
  h6: {
    color: palette.text.primary,
    fontWeight: '500',
    fontSize: '20px',
    letterSpacing: '0.15px',
    lineHeight: '24px',
  },
  subtitle1: {
    color: palette.text.primary,
    fontSize: '16px',
    letterSpacing: '0.15px',
    lineHeight: '24px',
  },
  subtitle2: {
    color: palette.text.primary,
    fontWeight: '500',
    fontSize: '14px',
    letterSpacing: '0.1px',
    lineHeight: '24px',
  },
  body1: {
    color: palette.text.primary,
    fontSize: '16px',
    letterSpacing: '0.5px',
    lineHeight: '24px',
  },
  body2: {
    color: palette.text.primary,
    fontSize: '14px',
    letterSpacing: '0.25px',
    lineHeight: '20px',
  },
  button: {
    color: palette.text.primary,
    fontWeight: '500',
    fontSize: '14px',
    letterSpacing: '1.25px',
    lineHeight: '16px',
    textTransform: 'uppercase',
  },
  caption: {
    color: palette.text.secondary,
    fontSize: '12px',
    letterSpacing: '0.4px',
    lineHeight: '16px',
  },
  overline: {
    color: palette.text.secondary,
    fontWeight: '500',
    fontSize: '10px',
    letterSpacing: '1.5px',
    lineHeight: '16px',
    textTransform: 'uppercase',
  },
};
